import { DadosProgramaManutencao } from "../model/entities/ProgramaManutencao";
import api from "./api";

const ROUTE = "programa_manutencao";

class programaManutencaoApi {
  async getById(id: number) {
    try {
      const res = await api.get<DadosProgramaManutencao>(`/${ROUTE}/${id}`);
      const data = res.data;

      return data;
    } catch (error: any) {
      console.log(error);
      throw error;
    }
  }
  async getMany(
    pagina: number,
    linhasPorPagina: number,
    campoOrdenacao: string = "id",
    direcao: "asc" | "desc" = "asc"
  ) {
    try {
      const res = await api.get(
        `/${ROUTE}?size=${linhasPorPagina}&page=${pagina}&sort=${campoOrdenacao},${direcao}`
      );
      const data = res.data;

      return data;
    } catch (error: any) {
      console.log(error);
      throw error;
    }
  }

  async count() {
    try {
      const res = await api.get<number>(`/${ROUTE}/count`);
      const data = res.data;
      return data;
    } catch (error: any) {
      console.log(error);
      throw error;
    }
  }
}

const apiProrgamaManutencao = new programaManutencaoApi();
export default apiProrgamaManutencao;
